/**
 * Executes deferred slot scripts inside their PDP content slot container
 * so inline JS can scope DOM queries to slotRoot instead of the document.
 *
 * Content authors: use <script type="text/pdp-slot-script"> and reference
 * the slotRoot variable (e.g. slotRoot.querySelector('.my-class')).
 */
(function () {
  /**
   * @param {HTMLElement} slotRoot
   */
  function initPdpContentSlot(slotRoot) {
    if (slotRoot.dataset.pdpSlotReady === 'true') {
      return;
    }

    slotRoot.dataset.pdpSlotReady = 'true';

    const deferredScripts = slotRoot.querySelectorAll('script[type="text/pdp-slot-script"]');

    for (const templateScript of deferredScripts) {
      if (!(templateScript instanceof HTMLScriptElement)) {
        continue;
      }

      const script = document.createElement('script');

      if (templateScript.src) {
        script.src = templateScript.src;

        if (templateScript.defer) {
          script.defer = true;
        }

        if (templateScript.async) {
          script.async = true;
        }
      } else {
        const slotId = slotRoot.id;
        script.textContent = `(function() {
  var slotRoot = document.getElementById(${JSON.stringify(slotId)});
  if (!slotRoot) return;
  ${templateScript.textContent}
})();`;
      }

      templateScript.replaceWith(script);
    }
  }

  function initAllPdpContentSlots() {
    const slots = document.querySelectorAll('[data-pdp-content-slot]');

    for (const slot of slots) {
      if (!(slot instanceof HTMLElement)) {
        continue;
      }

      initPdpContentSlot(slot);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllPdpContentSlots);
  } else {
    initAllPdpContentSlots();
  }

  document.addEventListener('shopify:section:load', initAllPdpContentSlots);
})();
